"use client"

// import Link from "next/link"
import { BookOpen, Users, MessageSquare, FileText, LayoutDashboard, ChevronLeft, ChevronRight } from "lucide-react"
import { useEffect, useState } from "react"
import { Button } from "src/components/ui/button"

export default function Sidebar() {
    const [appName, setAppName] = useState("App_name")
    const [isCollapsed, setIsCollapsed] = useState(false)
    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };
    const fetchApplicationKeyValue = async (tenantId, appId, keyPath) => {
        const url = `https://dev-bex.coolriots.ai/bexo/api/v2/applications/list_by_id/${tenantId}/${appId}`;

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

            const data = await response.json();
            const value = getNestedValue(data, keyPath);

            if (value !== undefined) {
                return value;
            } else {
                console.warn(`Key path "${keyPath}" not found in response.`);
                return null;
            }
        } catch (error) {
            console.error('Fetch error:', error);
            return null;
        }
    };
    // Simulate fetching app name based on user login
    useEffect(() => {
        // This would typically be a fetch call to your API
        const fetchAppName = async () => {
            const userDataString = localStorage.getItem("userData");
            const userData = JSON.parse(userDataString);
            try {
                // Simulate API call delay
                await new Promise((resolve) => setTimeout(resolve, 500))

                // This would be the data from your API

                fetchApplicationKeyValue(
                    userData.tenant_id, userData.app_id,
                    'full_name'
                ).then(value => {
                    console.log('Full Name:', value); // Output: ""
                    setAppName(value)

                });
                // setAppName(userData.appName)
            } catch (error) {
                console.error("Failed to fetch application data", error)
            }
        }

        fetchAppName()
    }, [])

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed)
    }

    return (
        <div
            className={`flex flex-col border-r bg-white transition-all duration-300 ease-in-out h-screen ${isCollapsed ? "w-20" : "w-64"
                }`}
        >
            <div className="p-4 flex justify-between items-center">
                <div className={`flex items-center gap-2 ${isCollapsed ? "hidden" : "flex"}`}>
                    <LayoutDashboard className="h-6 w-6 text-[#b10a2b]" />
                    <span className="text-xl font-bold">{appName}</span>
                </div>
                {isCollapsed && <LayoutDashboard className="h-6 w-6 text-[#b10a2b] mx-auto" />}
                <Button
                    variant="ghost"
                    size="icon"
                    onClick={toggleSidebar}
                    className={`h-8 w-8 ${isCollapsed ? "ml-auto" : ""}`}
                >
                    {isCollapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
                </Button>
            </div>
            <nav className="flex-1 p-4 space-y-2">
                {/* <Link href="/" className="flex items-center p-3 text-gray-900 rounded-md hover:bg-gray-100">
                    <BookOpen className="h-5 w-5 min-w-5" />
                    {!isCollapsed && <span className="ml-3">Home</span>}
                </Link>
                <Link href="#" className="flex items-center p-3 text-gray-900 rounded-md hover:bg-gray-100">
                    <FileText className="h-5 w-5 min-w-5" />
                    {!isCollapsed && <span className="ml-3">Update Profile</span>}
                </Link>
                <Link href="#" className="flex items-center p-3 text-gray-900 rounded-md hover:bg-gray-100">
                    <Users className="h-5 w-5 min-w-5" />
                    {!isCollapsed && <span className="ml-3">Notification</span>}
                </Link>
                <Link href="#" className="flex items-center p-3 text-gray-900 rounded-md hover:bg-gray-100">
                    <MessageSquare className="h-5 w-5 min-w-5" />
                    {!isCollapsed && <span className="ml-3">Settings</span>}
                </Link> */}
            </nav>
        </div>
    )
}
